module.exports = __webpack_public_path__ + "img/store_googleplay.d4ac05e1.png";